import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1420.21 1801.85"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}")
        ])),
        _: 1
      })),
      _cache[1] || (_cache[1] = _createElementVNode("linearGradient", {
        id: "linear-gradient",
        x1: "1000",
        y1: "1910.72",
        x2: "1000",
        y2: "124.86",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": "#2f2ee1"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#8080f0"
        })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("linearGradient", {
        id: "linear-gradient-2",
        x1: "710.1",
        y1: "1811.64",
        x2: "710.1",
        y2: "25.78",
        "xlink:href": "#linear-gradient"
      }, null, -1))
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      class: "cls-1",
      cx: "1038.94",
      cy: "1164.36",
      r: "20.41"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      class: "cls-2",
      d: "M1000,99.07c-438.35,0-710.1,271.75-710.1,710.1s271.75,710.11,710.1,710.11,710.1-271.75,710.1-710.11S1438.35,99.07,1000,99.07ZM1000,1245c-269.36,0-409.8-166.42-409.8-435.78S730.64,373.39,1000,373.39s409.81,166.42,409.81,435.78S1269.36,1245,1000,1245Z",
      transform: "translate(-289.9 -99.07)"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("rect", {
      class: "cls-3",
      x: "210.98",
      y: "1597.36",
      width: "998.25",
      height: "204.49"
    }, null, -1))
  ]))
}
export default { render: render }